import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { RadioSwitch } from 'components';

class ContentSwitch extends React.Component {
    constructor(props) {
        super(props);

        const { defaultSelected } = this.props;

        this.state = {
            selected: defaultSelected,
            optionsAddedToDom: { [defaultSelected]: true }
        };
    }

    /**
     * @param {string} target - new selected value (option) coming from RadioSwitch
     * @summary sets new selected and adds the option to list of items that should be rendered
     */
    onSwitch = target => {
        const { onSwitch } = this.props;

        this.setState(prevState => {
            return {
                selected: target,
                optionsAddedToDom: {
                    ...prevState.optionsAddedToDom,
                    ...{ [target]: true }
                }
            };
        });

        if (onSwitch) {
            onSwitch(target);
        }
    };

    render() {
        const { options } = this.props;
        const { selected, optionsAddedToDom } = this.state;

        return (
            <Fragment>
                <section className="d-flex justify-content-center mb-4">
                    <div style={{ maxWidth: '35rem' }} className="w-100 mx-2">
                        <RadioSwitch
                            id={'radio-switch-1'}
                            cssClass="form-control-radio-switch-lg"
                            options={Object.keys(options).map(key => ({
                                value: key,
                                name: options[key].label
                            }))}
                            checked={selected}
                            handleOnChange={this.onSwitch}
                        />
                    </div>
                </section>
                <section className="pt-2">
                    {Object.keys(optionsAddedToDom).map((key, index) => (
                        <div
                            key={`${index}`}
                            style={
                                `${key}` === selected ? {} : { display: 'none' }
                            }>
                            {options[key].node}
                        </div>
                    ))}
                </section>
            </Fragment>
        );
    }
}

ContentSwitch.propTypes = {
    defaultSelected: PropTypes.string.isRequired,
    options: PropTypes.object.isRequired,
    onSwitch: PropTypes.func
};

export default ContentSwitch;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/recommendations/content-switch.jsx